export default __webpack_public_path__ + "static/media/magic_wand_icon.d323878a.svg";